import { useEffect, useState } from 'react';
import Checkbox from '@sdk/components/forms/Checkbox';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Row from '@sdk/components/ui/spacing/Row';

import { useShouldShow } from '@web/common/hooks/useShouldShow';

import { CheckboxLabel } from './styles';
import { Props } from './types';

export const Inner = ({ about, currentUser }: Props) => {
  const { dontShowAgain, shouldShow } = useShouldShow(about, currentUser);
  const [selected, setSelected] = useState(!shouldShow());
  const handleChange = () => setSelected(!selected);

  useEffect(() => {
    dontShowAgain(selected);
  }, [dontShowAgain, selected]);

  return (
    <Row>
      <Checkbox onChange={handleChange} value={selected} />
      <CheckboxLabel onClick={handleChange}>
        <Text14 themeColor={ThemeColorType.gray}>Don&#39;t ask me again</Text14>
      </CheckboxLabel>
    </Row>
  );
};
